export function loadState<T>(suffix: string): T | undefined {
  try {
    const serializedState = localStorage.getItem(suffix);
    if (!serializedState) return undefined;
    return JSON.parse(serializedState) as T;
  } catch {
    return undefined;
  }
}

export function saveState<T>(suffix: string, state: T): void {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(suffix, serializedState);
  } catch {
    // Ignore
  }
}

export function removeState(suffix: string): void {
  try {
    localStorage.removeItem(suffix);
  } catch {
    // Ignore
  }
}
